export const StatusCodeConstant = {
    Ok: 200,
    Found: 302
}
